import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Popover, Grid, Typography, MenuList, MenuItem, Divider } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

import Routes from "config/routes";
import { initialsForName } from "utils/helpers";

const MobileMenu = ({
  classes,
  authUser,
  tabletUpScreen,
  onSignOut,
  onSignIn,
  onSignUp,
  onFindBooking,
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuOpen = (e) => {
    setMenuAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleSignOut = () => {
    onSignOut();
    handleMenuClose();
  };

  const handleSignIn = () => {
    onSignIn();
    handleMenuClose();
  };

  const handleSignUp = () => {
    onSignUp();
    handleMenuClose();
  };

  const handleFindBooking = () => {
    onFindBooking();
    handleMenuClose();
  };

  return (
    <>
      <Button color="inherit" onClick={handleMenuOpen} className={classes.menuButton}>
        <Grid container alignItems="center" justifyContent="center">
          {authUser ? (
            <div className={classes.avatar}>
              <Typography variant="caption" className={classes.initials}>
                {initialsForName(authUser?.displayName)}
              </Typography>
            </div>
          ) : tabletUpScreen ? (
            <Typography variant="button" className={classes.menuText}>
              Menu
            </Typography>
          ) : null}
          <MenuIcon />
        </Grid>
      </Button>

      <Popover
        open={menuOpen}
        anchorEl={menuAnchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}>
        {authUser ? (
          <MenuList className={classes.menu}>
            <MenuItem component={Link} to={Routes.ACCOUNT}>
              My account
            </MenuItem>
            <Divider light className={classes.menuDivider} />
            <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
          </MenuList>
        ) : (
          <MenuList className={classes.menu}>
            <MenuItem onClick={handleSignIn}>Log in</MenuItem>
            <MenuItem onClick={handleSignUp}>Sign up</MenuItem>
            <Divider light className={classes.menuDivider} />
            <MenuItem onClick={handleFindBooking}>Manage booking</MenuItem>
          </MenuList>
        )}
      </Popover>
    </>
  );
};

MobileMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  authUser: PropTypes.object,
  tabletUpScreen: PropTypes.bool.isRequired,
  onSignOut: PropTypes.func.isRequired,
  onSignIn: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired,
  onFindBooking: PropTypes.func.isRequired,
};

export default MobileMenu;
